// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"984":"03f7e782","3142":"b2531595","3352":"c2f84a0d","3690":"0593339e","4924":"cd35db14","5006":"b2ca8117"}[chunkId] + ".css";
};